// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea-module__textarea___aDm73","variant-error":"Textarea-module__variant-error___cYg4P","variantError":"Textarea-module__variant-error___cYg4P"};